<div class="RestartWarning">
	<div class="RestartWarning-body">
		<div class="RestartWarning-icon">
			<fa-icon [icon]="faClock" [fixedWidth]="true" slot="start"></fa-icon>
		</div>
		<div class="RestartWarning-heading">
			<h2>Kiosk will restart Soon</h2>
		</div>
		<div class="RestartWarning-body">
			<p>For your security, Kiosk will restart when you have not been active for a certain amount of time.</p>
		</div>
		<div class="RestartWarning-timer">
			{{ countdownClock }}
		</div>
	</div>

	<div class="RestartWarning-footer">
		<ion-button fill="outline" (click)="restart()">Restart</ion-button>
		<ion-button fill="solid" (click)="confirm()">Continue Session</ion-button>
	</div>
</div>
